/** @jsxImportSource @emotion/react */

import React, { Component } from 'react';
import { connect } from 'unistore/react';
import { css } from '@emotion/react';

// import BbTradeTable from './buynsell-Table';
import TradeTable from './tradeTable';

import DropDown from '../../../components/DropDown';

import {
	getINRDecimals,
	currenciesList,
	getCurrencyProperty,
	getCurrencyFromCode,
	getCurrencyProps,
} from '@utils/params';
import { dashboardActions } from '@utils/store/actions';

const formattedCurr = (currency, id) => {
	let currArg = currency;

	if (!currArg) {
		currArg = getCurrencyFromCode(id);
	}

	const { sym, curr } = getCurrencyProps(currArg);

	if (sym.trim() === curr.trim()) {
		return curr;
	}
	return `${curr} ${sym}`;
};

class BbTradeTables extends Component {
	constructor(props) {
		super(props);
		const {
			currentTradingCoin: { coin },
			currentShownCurrency,
		} = props;

		this.state = {
			inrDecimals: getINRDecimals(coin, currentShownCurrency),
		};
	}

	componentDidMount = () => {
		const {
			currentTradingCoin: { coin, market_id },
			currentShownCurrency,
		} = this.props;

		this.setMultipliers(coin, market_id, currentShownCurrency);
	};

	componentDidUpdate(prevProps) {
		const {
			currentTradingCoin: { coin, market_id },
			currentShownCurrency,
		} = this.props;

		if (
			prevProps.currentTradingCoin.coin !== coin ||
			prevProps.currentShownCurrency !== currentShownCurrency
		) {
			this.setMultipliers(coin, market_id, currentShownCurrency);
		}
	}

	toggleCurrSelector = (val, fn) => {
		this.setState(
			{
				currSelector: val,
			},
			() => {
				fn();
			}
		);
	};

	changeCurrency = e => {
		const { __toggleCurrentShownCurrency } = this.props;

		__toggleCurrentShownCurrency(
			getCurrencyProperty(e.target.dataset.curr, 'id')
		);
	};

	setMultipliers = (coin, market_id, currentShownCurrency) => {
		switch (coin) {
			case 'btc':
				if (market_id !== 1) {
					this.setState({
						inrDecimals: getINRDecimals(coin, currentShownCurrency),
					});
				} else {
					this.setState({
						inrDecimals: getINRDecimals(coin, currentShownCurrency),
					});
				}
				break;
			default:
				this.setState({
					inrDecimals: getINRDecimals(coin, currentShownCurrency),
				});
		}
	};

	render() {
		const {
			currentTradingCoin: { coin },
			currentShownCurrency,
			coinName,
		} = this.props;
		const { inrDecimals, currSelector } = this.state;
		const coinUpper = coin.toUpperCase();

		return (
			<div className="bb-trade-tables pt-4 pb-4" id="bb-tradeTables">
				<div className="text-lightGray text-sm mb-4 flex items-center justify-between">
					<h3 className="text-lg font-bold text-dharkyBhicky m-0">
						{coinName} Price INR History
					</h3>
					{coinUpper === 'RAM' ? (
						<div className="text-xs text-right text-lightGray">
							* 10B = 10 Bytes
						</div>
					) : (
						<div />
					)}
					<div>
						Showing Prices in{' '}
						<DropDown
							closeOnSelect
							className="c-btn c-btn--outline c-btn--tiny bb-currencies__dropDown"
							activeClassName="bb-currencies__btn--open"
							position="bottomLeft"
							toggleMenu={this.toggleCurrSelector}
							showMenu={currSelector}
							renderSelected={() => (
								<div>
									{formattedCurr(
										undefined,
										currentShownCurrency
									)}{' '}
									&#9660;
								</div>
							)}
							css={css`
								z-index: 1;
							`}
						>
							<div
								className="overflow-auto"
								style={{
									maxHeight: '400px',
								}}
							>
								{currenciesList.map(curr => (
									<div
										className="bb-dropdownItem text-sm whitespace-nowrap normal-case font-normal u-text-spacing--normal font-bold"
										data-curr={curr}
										key={curr}
										onClick={this.changeCurrency}
										css={css`
											min-width: 80px;
										`}
									>
										{formattedCurr(curr)}
									</div>
								))}
							</div>
						</DropDown>
					</div>
				</div>
				<div className="bb-tradeTables__wrap">
					<div className="bb-tradeTables__col">
						<div className="c-table__scrollWrapper">
							<TradeTable
								coinUpper={coinUpper}
								inrDecimals={inrDecimals}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	'currentTradingCoin, currentShownCurrency',
	dashboardActions
)(BbTradeTables);
